import { tableEntryStyle } from "../../../shared/TableHeader";
import { formatDisplayDate } from "../../../utils/date";
import { useSharedContentToken } from "../../../queries/auth";
import { useEffect, useMemo, useState } from "react";
import IframePopupDialog from "./IFramePopup";
import { useAuthStore } from "../../../store/useAuthStore";
import { trackEvent } from "../../../utils/AmpAnalytics";

export function DateOfSharedRender(data: any) {
  return (
    <div className="whitespace-nowrap pt-1">
      <p className={`${tableEntryStyle}`}>
        {formatDisplayDate(data.data.dateOfShared)}
      </p>
    </div>
  );
}

export function CompanyNameRender(data: any) {
  return (
    <div className="whitespace-nowrap pt-1 font-semibold">
      <p className={tableEntryStyle}>
        {data.data.companyName ? data.data.companyName : "-"}
      </p>
    </div>
  );
}

const platformToUrl = (platform: string) => {
  switch (platform) {
    case "CAPTABLE":
      return process.env.REACT_APP_CAPTABLE_URL;
    case "ESOP":
      return process.env.REACT_APP_ESOP_URL;
    case "PORTFOLIO":
      return process.env.REACT_APP_INVESTOR_URL;
    case "TASK MANAGER":
      return process.env.REACT_APP_TASKMANAGER_URL;
    default:
      return "";
  }
};

export function getSharedURL(
  token: string,
  platform: string,
  resourceId: string
) {
  const currentPlatform = platformToUrl(platform);
  const url = `${currentPlatform}/share/${resourceId}?shareAccessToken=${token}`;
  return url;
}

export function PageNameRender(data: any) {
  const [isOpen, setIsOpen] = useState(false);
  const [resourceId, setResourceId] = useState<any>();
  const [url, setUrl] = useState("");
  const { mutate: getSharedContentToken } = useSharedContentToken();
  const { accessToken } = useAuthStore();

  useEffect(() => {
    if (resourceId)
      getSharedContentToken(
        {
          data: data?.data?.currentRowData,
          token: `${accessToken}`,
        },
        {
          onSuccess: (tokenData) => {
            const currentUrl = getSharedURL(
              tokenData.data,
              data.data.platform,
              resourceId
            );
            setUrl(currentUrl);
          },
          onError: () => {},
        }
      );
  }, [resourceId]);

  return (
    <div
      onClick={() => {
        // handleClickForTracking(AnalyticsConstant.shared_content_view_button);
        trackEvent(`Viewing Shared Page${data?.data?.companyName ? ` - ${data?.data?.companyName}` : ''}`
);
        setIsOpen(true);
      }}
    >
      <IframePopupDialog
        name={data.data.resourceType}
        companyName={data.data.companyName}
        link={url}
        open={isOpen}
        close={() => setIsOpen(false)}
        label={true}
        onClick={() => setResourceId(data.data.resourceId)}
      />
    </div>
  );
}
